
import moment = require("moment");
import { FilterState } from "../classes/filter-state";
import { IEvent, FilterFunction } from "../interfaces";
import { hashFilters } from "./hash-filters";

export interface IRestrictedRange {
    restricted: boolean;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
}

const functionCache = {};
/**
 * Returns a function compatible with the `Array.prototype.filter` API to filter events.
 * 
 * Relies heavily on caching to prevent re-checking events.
 */
export function composeFilterFunction(range: IRestrictedRange, ...filters: FilterState<IEvent>[]): [FilterFunction, number] {

    // hash the applied filters and get a key
    const filterHashKey = hashFilters(range.restricted, ...filters);

    // check for a cached function based on the key
    let cachedFunction: FilterFunction = functionCache[filterHashKey];
    if (cachedFunction) {
        // return the found function
        return [cachedFunction, filterHashKey];
    }

    // create a new function if this is an uncached filter state
    const filterCache = {};
    cachedFunction = (events: IEvent[]) => {
        return events.filter(event => {

            // leverage caching based on eventId to boost filter speed in the future
            let cachedResult: boolean = filterCache[event.id]
            if (cachedResult !== undefined) {
                // return the cached result (true or false)
                return cachedResult;
            }

            // check whether or not the event passes the filter
            cachedResult = !range.restricted || (range.restricted && moment(event.eventDate).isBetween(range.startDate, range.endDate.endOf('day')));
            for (let i = 0; i < filters.length; i++) {
                cachedResult = cachedResult && filters[i].filter(event)
            }

            // cache and return the result
            filterCache[event.id] = cachedResult;
            return cachedResult;
        });
    };

    // cache and return the filter
    functionCache[filterHashKey] = cachedFunction;
    return [cachedFunction, filterHashKey];
}
